import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { SearchResultsRepository } from '../repositories/search-result.repository';

@Injectable({ providedIn: 'root' })
export class SearchResultsQuery {
  constructor(private searchResultsRepository: SearchResultsRepository) {}

  selectSearchResult() {
    return this.searchResultsRepository.searchResults$.pipe(
      map((result) => {
        if (this.searchResultsRepository.getTotalSearchAmount() === -1) {
          return;
        }

        return {
          result: result,
          totalAmount: this.searchResultsRepository.getTotalSearchAmount(),
          bisnodeNotResponding:
            this.searchResultsRepository.getBisnodeNotResponding(),
        };
      }),
    );
  }
}
